export var RequestStatus;
(function (RequestStatus) {
    RequestStatus["NOT_STARTED"] = "notStarted";
    RequestStatus["REQUESTING"] = "requesting";
    RequestStatus["SUCCESS"] = "success";
    RequestStatus["FAILURE"] = "failure";
})(RequestStatus || (RequestStatus = {}));
export function NotStarted() {
    return { type: RequestStatus.NOT_STARTED };
}
export function Requesting() {
    return { type: RequestStatus.REQUESTING };
}
export function Success(result) {
    return { type: RequestStatus.SUCCESS, result: result };
}
export function Failure(reason) {
    return { type: RequestStatus.FAILURE, reason: reason };
}
